import React, { useContext, useState, useEffect } from "react";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterModal from "./component/modal/FilterModal";
import { StoreContext } from "../../store";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import "./index.css";
import instance from "../../common/api/interceptor";
import { path } from "../../constants/apiPath";
import Loading from "../loading/Loading";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import InfiniteScroll from "react-infinite-scroller";
import exportFromJSON from "export-from-json";
import ListIcon from "@mui/icons-material/List";
import SelectColumn from "./component/modal/SelectColumn";
import columnName from "./component/data";
import Paper from "@material-ui/core/Paper";
import axios from "axios";
import NoData from "../noData/NoData";
import { filterDataObject } from "./component/data/FilterDataObject";
import { isArray } from "lodash";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
function OrderReport() {
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(true);
  const [orderBy, setOrderBy] = useState("");
  const [order, setOrder] = useState("");
  const [modalType, setModalType] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const pageSize = 20;
  const [activeColumn, setActiveColumn] = useState([...columnName]);
  const [orderActiveCol, setOrderActiveCol] = useState({});
  const [bodyData, setBodyData] = useState({ ...filterDataObject });
  const [isRateSelected, setIsRateSelected] = useState(false);
  const [report, setReport] = useState({
    data: [],
    hasMore: false,
  });
  const reportDataTemp = context.reportData.map((indvData) => {
    const tempData = {
      ...indvData,
      ContainerCount:
        indvData.OrderContainerRates === ""
          ? ""
          : indvData.OrderContainerRates?.split(",").length,
      TotalCost:
        indvData.OrderContainerRates === ""
          ? ""
          : `$${indvData.OrderContainerRates?.split(",")
              .map((indvShip) => indvShip?.split("-")[1])
              .reduce((acc, curr) => parseInt(acc) + parseInt(curr), 0)
              .toFixed(2)}`,
      OrderContainerRates: indvData.OrderContainerRates?.split(",")
        .map((indvShip) => indvShip?.split("-").join("- $"))
        .join(", "),
    };
    return tempData;
  });

  const orderActiveColTemp = { ...orderActiveCol };
  if (orderActiveCol.OrderContainerRates) {
    orderActiveColTemp.ContainerCount = true;
    orderActiveColTemp.TotalCost = true;
  } else {
    orderActiveColTemp.ContainerCount = false;
    orderActiveColTemp.TotalCost = false;
  }
  useEffect(() => {
    getColumnName();
  }, []);
  useEffect(() => {
    if (isRateSelected) {
      let updatedCols = columnName.filter((item) => {
        return item.key !== "ContainerCount";
      });
      updatedCols.filter((item) => {
        return item.key !== "TotalCost";
      });
      updateColumnName(updatedCols);
    }
  }, [columnName]);
  const findRatesVal = () => {
    let tempobj = columnName.filter((item) => {
      return item.key === "OrderContainerRates";
    });
    if (tempobj[0].Selected) {
      setIsRateSelected(true);
    }
  };
  useEffect(() => {
    findRatesVal();
  }, [columnName]);
  const onLoadMore = () => {
    const count = pageNumber + 1;
    getOrderReport(order, orderBy, count, pageSize, { ...bodyData });
  };

  const getOrderReport = async (
    SortColumnName = order,
    SortDirection = orderBy,
    CurrentPage = pageNumber,
    PageSize = pageSize,
    bodyData
  ) => {
    if (CurrentPage === 0) {
      setLoading(true);
    }
    setHasMore(false);
    const body = {
      ...bodyData,
      SortColumnName,
      SortDirection,
      CurrentPage,
      PageSize,
    };
    await instance
      .post(path.GET_REPORT, body)
      .then((res) => {
        if (res.Is_Success) {
          context.setReportData((prev) => [...prev, ...(res.data ?? [])]);
          setPageNumber(CurrentPage);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        let hasMorecheck = res.data?.length === pageSize ? true : false;
        setHasMore(hasMorecheck);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setReportData([]);
        setLoading(false);
      });
  };

  const onDownload = () => {
    context.setBackDropOpen(true);
    const body = {
      _ColList: "",
      ...bodyData,
      ColList: "",
      SortColumnName: "",
      SortDirection: "",
      CurrentPage: 0,
      PageSize: 0,
    };
    instance
      .post(path.DOWNLOAD_ORDER_REPORT, body)
      .then((res) => {
        if (res.Is_Success) {
          if (res.data[0].OrderContainerRates != undefined) {
            let data2 = res.data.map((item) => {
              const tempData = {
                ...item,
                ContainerCount:
                  item.OrderContainerRates === ""
                    ? ""
                    : item.OrderContainerRates?.split(",").length,
                TotalCost:
                  item.OrderContainerRates === ""
                    ? ""
                    : `$${item.OrderContainerRates?.split(",")
                        .map((indvShip) => indvShip?.split("-")[1])
                        .reduce(
                          (acc, curr) => parseInt(acc) + parseInt(curr),
                          0
                        )
                        .toFixed(2)}`,
                OrderContainerRates: item.OrderContainerRates?.split(",")
                  .map((indvShip) => indvShip?.split("-").join("- $"))
                  .join(", "),
              };
              return tempData;
            });
            downloadExcel(data2);
          } else {
            downloadExcel(res.data);
          }
          context.setBackDropOpen(false);
        } else {
          NotificationManager.error(res.Message, "", 3000);
          context.setBackDropOpen(false);
        }
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };
  const ExportExcel = (excelData, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8";
    const fileExtension = ".xlsx";
    const exportToExcel = async () => {
      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = {
        Sheets: { "Order Reports": ws },
        SheetNames: ["Order Reports"],
      };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });

      FileSaver.saveAs(data, fileName + fileExtension);
    };
    exportToExcel();
  };

  const downloadExcel = (data) => {
    const fileName = "Order Reports";
    const exportType = exportFromJSON.types.xls;

    if (data.length) {
      handleComma(data)
        .then((res) => {
          const currentDate = new Date();

          // Extract the individual date components
          const month = String(currentDate.getMonth() + 1).padStart(2, "0");
          const day = String(currentDate.getDate()).padStart(2, "0");
          const year = currentDate.getFullYear();

          // Format the date string
          const formattedDate = `${month}-${day}-${year}`;
          let repName = `Order Report as on : ${formattedDate}`;
          const exceljson = JSON.parse(JSON.stringify(res));
          ExportExcel(exceljson, repName);
          // removed to implement xlsx format
          // if (isArray(exceljson)) {
          //   exportFromJSON({
          //     data,
          //     fileName,
          //     exportType,
          //     // beforeTableEncode: (entries) => {
          //     //   console.log(entries);
          //     // },
          //   });
          // }
        })
        .catch((error) => {
          console.log("errr", error);
        });
    }
  };

  const handleComma = (data) => {
    return new Promise((resolve, reject) => {
      const jsonForExcel = JSON.parse(JSON.stringify(data)); // Deep copy to prevent mutation of original data
      jsonForExcel?.forEach((item, index, arr) => {
        Object.keys(item).forEach((key) => {
          if (typeof item[key] === "string" && item[key].includes(",")) {
            const replaced = item[key].replaceAll(",", ", ");
            arr[index][key] = replaced;
          } else {
            arr[index][key] = `${item[key]}`;
          }
        });
      });
      resolve(jsonForExcel);
    });
  };

  const getColumnName = () => {
    instance
      .get(path.GET_COLUMN_NAME)
      .then((res) => {
        if (res.Is_Success) {
          setOrderActiveCol(res.data);
          getOrderReport(order, orderBy, 0, pageSize, { ...bodyData });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onFillterHandler = (body) => {
    getOrderReport(order, orderBy, 0, pageSize, { ...body });
    setBodyData({ ...body });
  };

  const updateColumnName = (columnName) => {
    const body = { ...columnName };

    instance
      .post(path.UPDATE_COLUMN_NAME, body)
      .then((res) => {
        if (res.Is_Success) {
          setOrderActiveCol({ ...body });
          context.setModalOpen(false);
          NotificationManager.success(res.Message, "", 3000);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch(() => {});
  };

  const handleRequestSort = async (event, property) => {
    setPageNumber(0);
    await context.setReportData([]);
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    getOrderReport(isAsc ? "desc" : "asc", property, 0, pageSize, {
      ...bodyData,
    });
  };

  const onCheckboxChange = (ele, index) => {
    const arr = [...activeColumn];
    arr[index].Selected = !arr[index].Selected;
    setActiveColumn([...arr]);
  };

  const EnhancedTableHead = ({ column, order, orderBy, onRequestSort }) => {
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {activeColumn.map((ele, index) => {
            return (
              orderActiveColTemp[ele.key] && (
                <TableCell key={index}>{ele.Level}</TableCell>
              )
            );
          })}
        </TableRow>
      </TableHead>
    );
  };
  return (
    <>
      <div className="_systemLog">
        <div className="_sytemSortDialog">
          <div className="_systemLogFilterParent">
            <div
              className="_systemLogFilter"
              onClick={() => {
                context.setModalOpen(true);
                setModalType("filter");
              }}
            >
              <FilterAltOutlinedIcon />
            </div>
            <div
              className="_systemLogFilter"
              onClick={() => {
                context.setModalOpen(true);
                setModalType("column");
              }}
            >
              <ListIcon />
            </div>
          </div>

          <div className="_outlineButton">
            <button onClick={onDownload}>Download Report</button>
          </div>
        </div>
        <div className={`_tableScroll _systemLogTable reportTable`}>
          {loading ? (
            <Loading />
          ) : (
            <TableContainer
              component={Paper}
              className="_tableScrollTableContainer"
            >
              {!context.reportData.length ? (
                <NoData>
                  <p>Report not Found!</p>
                </NoData>
              ) : (
                <InfiniteScroll
                  className="infiniteScroller"
                  pageStart={0}
                  loadMore={onLoadMore}
                  hasMore={hasMore}
                  loader={
                    <div className="_scrollLoader">
                      <Loading />
                    </div>
                  }
                  useWindow={false}
                >
                  <Table stickyHeader id="downloadTable">
                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                    />
                    <TableBody>
                      {context.reportData.length &&
                        reportDataTemp.map((ele, index) => {
                          return (
                            <TableRow key={index}>
                              {activeColumn.map((item) => {
                                return (
                                  orderActiveColTemp[item.key] && (
                                    <TableCell>{ele[item.key]}</TableCell>
                                  )
                                );
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </InfiniteScroll>
              )}
            </TableContainer>
          )}
        </div>
      </div>
      {modalType === "filter" ? (
        <FilterModal
          setLoading={setLoading}
          onFillterHandler={onFillterHandler}
          pageSize={pageSize}
          bodyData={bodyData}
        />
      ) : (
        <SelectColumn
          onCheckboxChange={onCheckboxChange}
          columnName={columnName}
          orderActiveCol={orderActiveColTemp}
          setLoading={setLoading}
          getOrderReport={getOrderReport}
          updateColumnName={updateColumnName}
        />
      )}
    </>
  );
}

export default OrderReport;
